import { rune } from 'rune-ts';
import { $qs } from 'fxdom/es';
import { getProductColorInMaker } from '../../../Maker/F/getSth.js';
import { NewMakerEndServiceF } from '../../../NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';
import {
  ConnectUrlEvent,
  EditModeEvent,
  InputBlurredEvent,
  LinkToInput,
} from '../../../NewMaker/UI/LinkToInput/LinkToInput.ts';

export function setupLinkToInputEvents(link_to_input_el) {
  const nfc_product = G.mp.maker?.nfcProduct;
  if (!nfc_product) return;

  const linkToInput = rune.getView(link_to_input_el, LinkToInput);

  const is_short = $qs('html[marpplizer_mode="short"]');
  linkToInput.switchToMarpplizerMode?.(!!is_short);

  linkToInput.addEventListener(ConnectUrlEvent, handleConnectUrlEvent);
  linkToInput.addEventListener(InputBlurredEvent, handleInputBlurredEvent);
  linkToInput.addEventListener(EditModeEvent, handleEditModeEvent);
}

export function handleConnectUrlEvent(e) {
  const nfc_product = G.mp.maker?.nfcProduct;
  if (!nfc_product) return;

  const { original_url } = e.detail;
  const product = getProductColorInMaker();
  nfc_product.tempByTag(original_url, product);

  // if (nfc_product.uri) {
  //   return nfc_product.updateUrl(original_url, product);
  // } else {
  // return nfc_product.createByTag(original_url, product);
  // }
}

export function handleInputBlurredEvent(e) {
  const nfc_product = G.mp.maker?.nfcProduct;
  if (!nfc_product) return;
  const { input_value } = e.detail;
  nfc_product.input_value = input_value;

  const product = getProductColorInMaker();
  nfc_product.updateNfcInfoToSelectedOptionGroup(product);
}

export function handleEditModeEvent(e) {
  const nfc_product = G.mp.maker?.nfcProduct;
  if (!nfc_product) return;

  const { input_value } = e.detail;
  nfc_product.input_value = input_value;
  nfc_product.uri = undefined;
  nfc_product.original_url = undefined;

  const product = getProductColorInMaker();
  nfc_product.updateNfcInfoToSelectedOptionGroup(product);

  if (typeof NewMakerEndServiceF !== 'undefined' && NewMakerEndServiceF.userProduct?.stateChanged) {
    NewMakerEndServiceF.userProduct.stateChanged();
  }
}
